/**
 * gpsStore — IndexedDB wrapper for raw GPS sample arrays.
 *
 * Stored separately from syncQueue (which is fire-and-forget request queue).
 * Keyed by `sessionId` matching the history entry id.
 *
 * Future: when backend sync lands, a small uploader will read raw points by
 * sessionId, upload them via POST /api/activities/{id}/gps-points, then
 * optionally retain or roll up locally based on age.
 */
import { openDB } from 'idb';

const DB_NAME = 'enferno-gps';
const DB_VERSION = 1;
const STORE = 'points';

let dbPromise;

const getDB = () => {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE, { keyPath: 'sessionId' });
        }
      },
    });
  }
  return dbPromise;
};

export const savePoints = async (sessionId, points) => {
  const db = await getDB();
  await db.put(STORE, { sessionId, points, format: 1, savedAt: Date.now() });
};

export const getPoints = async (sessionId) => {
  const db = await getDB();
  const rec = await db.get(STORE, sessionId);
  return rec?.points || [];
};

export const removePoints = async (sessionId) => {
  const db = await getDB();
  await db.delete(STORE, sessionId);
};

export const listSessionIds = async () => {
  const db = await getDB();
  return db.getAllKeys(STORE);
};
